import { z } from 'zod';

export const contentKey = z.enum([
	'venue.name',
	'venue.nickname',
	'venue.telephone',

	'venue.streetAddress',
	'venue.suburb',
	'venue.state',
	'venue.country',
	'venue.postcode',

	'venue.address',
	'venue.emails',
	'venue.socials', 
	'lb',
	'rb',
]);
export type ContentKey = z.infer<typeof contentKey>;


const contentOptionsType = z.record(contentKey, z.string());
type ContentOptionsType = z.infer<typeof contentOptionsType>;

export const contentOptions: ContentOptionsType = {
	'venue.name': 'venue > name',
	'venue.nickname': 'venue > nick name',
	'venue.telephone': 'venue > main telephone',

	'venue.streetAddress': 'venue > street address',
	'venue.suburb': 'venue > suburb',
	'venue.state': 'venue > state',
	'venue.country': 'venue > country',
	'venue.postcode': 'venue > postcode',

	'venue.emails': 'venue > emails',
	'venue.socials': 'venue > socials',
	'lb': '{',
	'rb': '}',
};

